import React from 'react';
import PropTypes from 'prop-types';
import Switch from '4all-ui/components/Switch';
import Tag from '4all-ui/components/Tag';


import * as styles from './style';
import MenuTag from '../MenuTag';
import ActionBtn from '../ActionBtn';
import EditName from '../EditName';
import { MENU_ACTIONS_TYPE, MENU_ELEMENT_ID_PREFIX } from '../../helpers/constants';
import Helper from '../../helpers/Helper';
import { isUhuuMtkpc } from '../../helpers/uhuu';
import { UHUU_COLOR } from '../../styles/variables';

const getTags = (menu, merchantMktps) => {
  const tags = [];

  if (menu.marketplaces.length && (merchantMktps && merchantMktps.length)) {
    menu.marketplaces.forEach(menuMktp => {
      merchantMktps.forEach(mktp => {
        if (menuMktp === mktp.id) {
          tags.push({
            ...mktp,
            isPublished: menu.published,
          });
        }
      });
    });
  }

  return tags;
};

const lengthProducts = menu =>
  menu.categories.reduce(
    (total, item) => item.products.filter(prod => prod.status === 1).length + total,
    0
  );

const getMenuTag = menu => {
  return (
    <styles.ContentDetail>
      <MenuTag
        id={`service-types-menu-${menu.id}`}
        delivery={menu.delivery}
        takeaway={Helper.isIndoor(menu)}
      />
    </styles.ContentDetail>
  );
};

const getFooterContent = (menu, tags) => {
  if (isUhuuMtkpc(menu.marketplaces)) {
    if (menu.uhuuEvents.length) {
      return menu.uhuuEvents.map(event => (
        <Tag
          key={event.id}
          id={`menu-${menu.id}-uhuu-tag-event-${event.id}`}
          customStyles={{
            borderColor: UHUU_COLOR,
            backgroundColor: UHUU_COLOR,
            margin: '0 0 0 15px',
            fontSize: '12px',
          }}
        >
          {event.accountName}
        </Tag>
      ));
    }
  } else if (tags.length) {
    return tags.map(tag => (
      <Tag
        key={tag.id}
        id={`menu-${menu.id}-uhuu-tag-event-${tag.id}`}
        customStyles={{
          margin: '0 0 0 15px',
          fontSize: '12px',
        }}
      >
        {tag.name}
      </Tag>
    ));
  }

  return null;
};

const MenuItem = ({
  menu,
  merchantMktps,
  showEditName,
  menuEdit,
  hideEditName,
  updateName,
  onClickActions,
  publish,
}) => {
  const tags = getTags(menu, merchantMktps);
  const prodLength = lengthProducts(menu);

  return (
    <styles.MenuItem id={`${MENU_ELEMENT_ID_PREFIX}${menu.id}`}>
      <styles.MenuBody>
        <styles.MenuName>
          {showEditName && menuEdit.id === menu.id ? (
            <EditName
              label={`menu-name-${menu.id}`}
              value={menu.name}
              close={hideEditName}
              update={value => {
                updateName(menu, value);
              }}
            />
          ) : (
            <h2>{menu.name}</h2>
          )}
        </styles.MenuName>
        <styles.MenuContent>
          <styles.ContentDetail notPublished={!menu.published}>
            <Switch
              id={`switch-publish-menu-${menu.id}`}
              checked={menu.published}
              onChange={e => {
                publish(menu, e.target.checked);
              }}
            />
            <styles.PublishedLabel>PUBLICADO</styles.PublishedLabel>
          </styles.ContentDetail>
          <styles.ContentDetail>
            <styles.IconProducts />
            <styles.DescribeProducts id={`menu-products-qtty-${menu.id}`}>
              {prodLength}
            </styles.DescribeProducts>
          </styles.ContentDetail>
          {getMenuTag(menu)}
          <styles.ContentDetail>
            <ActionBtn
              id={`menu-actions-${menu.id}`}
              items={MENU_ACTIONS_TYPE}
              onClick={e => {
                onClickActions(e, menu, merchantMktps);
              }}
            />
          </styles.ContentDetail>
        </styles.MenuContent>
      </styles.MenuBody>
      <styles.MenuFooter>{getFooterContent(menu, tags)}</styles.MenuFooter>
    </styles.MenuItem>
  );
};

MenuItem.propTypes = {
  menu: PropTypes.object.isRequired,
  merchantMktps: PropTypes.array,
  showEditName: PropTypes.bool.isRequired,
  menuEdit: PropTypes.object,
  updateName: PropTypes.func.isRequired,
  onClickActions: PropTypes.func.isRequired,
  publish: PropTypes.func.isRequired,
  hideEditName: PropTypes.func.isRequired,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/MenuItem/index.js